import Immutable from 'immutable'

type ImmutableProduct = Immutable.Map<string, unknown>
type ImmutableCategory = Immutable.Map<string, unknown>

export const isNotAGift = (product: ImmutableProduct) =>
  (product.get('tags', Immutable.List()) as Immutable.List<string>).filter((tag) => tag === 'gift')
    .size === 0

type ProductCategory = {
  id: string
  label: string
  count: number
  order: number
}

export const getCategoriesFromProducts = (
  products: Immutable.Map<string, ImmutableProduct>,
  productCategories: Immutable.Map<string, ImmutableCategory>,
): Record<string, ProductCategory> => {
  const numberOfProducts = products.size

  const defaultCategories: Record<string, ProductCategory> = {
    'all-products': {
      id: 'all-products',
      label: 'All Products',
      count: numberOfProducts,
      order: 0,
    },
  }

  if (!numberOfProducts) {
    return defaultCategories
  }

  const categoriesAcc: Record<string, ProductCategory> = { ...defaultCategories }

  products.forEach((product) => {
    if (!product) return

    const productCategoriesList = product.get('categories') as Immutable.List<ImmutableCategory>

    productCategoriesList.forEach((category) => {
      if (!category || category.get('hidden')) return

      const categoryId = category.get('id') as string
      const categoryTitle = category.get('title') as string

      if (categoriesAcc[categoryId]) {
        categoriesAcc[categoryId].count += 1
      } else {
        categoriesAcc[categoryId] = {
          id: categoryId,
          label: categoryTitle,
          count: 1,
          order: productCategories.getIn([categoryId, 'order']) ?? 9999,
        }
      }
    })
  })

  const sortedCategories = Object.values(categoriesAcc)
    .sort((a, b) => a.order - b.order)
    .reduce<Record<string, ProductCategory>>((acc, category) => {
      acc[category.id] = category

      return acc
    }, {})

  return sortedCategories
}
